exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".m-list[data-v-4a8786e1]{border:1px solid #d3d3d3}.m-list-item[data-v-4a8786e1]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;height:40px;line-height:40px;border-bottom:1px solid #d3d3d3;padding:0 10px}.m-list-item[data-v-4a8786e1]:hover:nth-child(n+2){background-color:#e0ffff}.m-list-item-selected[data-v-4a8786e1]{background-color:#b0c4de}.m-list-title[data-v-4a8786e1]{font-size:16px;font-weight:700}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":false,"minimize":true}!./node_modules/vue-loader/lib/style-compiler?{"optionsId":"0","vue":true,"id":"data-v-4a8786e1","scoped":true,"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/tempManage/docTemp/index.vue
// module id = 2VGu
// module chunks = 57 239